import * as types from './mutation-types'

export default {
    [types.BOOTSTRAP_USERS](state, users) {
        state.users = users
    },
    [types.VIEW_USER](state, data) {
        state.viewUser = data
    },
    [types.SET_TOTAL_USERS](state, totalUsers) {
        state.totalUsers = totalUsers
    },
    [types.SET_SELECTED_USERS](state, data) {
        state.selectedUsers = data
    },

    [types.RESET_SELECTED_USER](state, data) {
        state.selectedUser = null
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.ADD_USER](state, data) {
        state.users.push(data.users)
    },
    [types.UPDATE_USER](state, data) {
        let pos = state.users.findIndex(user => user.id === data.user.id)

        state.users[pos] = data.user
    }

}